import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'

const AiChatRouteContext = createContext({
  humanSummary: null,
  setHumanSummary: () => {},
})

/**
 * Краткая подпись контекста страницы для чипа ИИ и строки «Сводка» в промпте
 * (например номер договора вместо UUID из URL).
 */
export function AiChatRouteProvider({ children }) {
  const [humanSummary, setHumanSummaryState] = useState(null)
  const setHumanSummary = useCallback((value) => {
    setHumanSummaryState(value)
  }, [])
  const value = useMemo(
    () => ({ humanSummary, setHumanSummary }),
    [humanSummary, setHumanSummary],
  )
  return (
    <AiChatRouteContext.Provider value={value}>
      {children}
    </AiChatRouteContext.Provider>
  )
}

export function useAiChatRouteSummary() {
  return useContext(AiChatRouteContext)
}
